import React from "react";
import MainContainer from "../../components/container";
import PersistentDrawer, { DrawnerElement } from "../../components/persistenDrawer";
import AddMeeting, { MeetingList } from "../../views/meetings";

// Vista principal del módulo de reuniones
const Reuniones: React.FC = () => {
    return (
        <MainContainer name="Reuniones">
            <ReunionesPanel />
        </MainContainer>
    )
};

// Panel interno que muestra las opciones del módulo
const ReunionesPanel: React.FC = () => {
    const elements: DrawnerElement[] = [
        { title: "Agregar Reunion", label: "Agregar Reunion", view: <AddMeeting /> }, // Vista para agregar reunión
        { title: "Lista de Reunones", label: "Lista de Reunones", view: <MeetingList /> } // Vista con listado de reuniones
    ];
    const [selected, setselected] = React.useState<DrawnerElement>(elements[0]); // Elemento seleccionado por defecto
    function onSavedPost(){
        setselected(elements[1]); // Cambia a la lista de reuniones
    };
    return(
        <PersistentDrawer selected={selected} setselected={setselected} elements={elements}></PersistentDrawer>
    )
}

export default Reuniones;